import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

type SubsectionHeaderProperties = Readonly<{
  children: ReactNode;
  className?: string;
}>;

/** A static (non-collapsible) subsection title bar — for grouping a block of fields under a heading without the collapse/toggle affordance of a full accordion. */
export function SubsectionHeader({ children, className }: SubsectionHeaderProperties) {
  return (
    <div
      className={cn(
        "bg-(--color-background-default-muted) text-primary p-(--spacing-2) font-(--font-weight-semibold) text-(length:--typography-base-sizes-extra-small-font-size)/(--typography-base-sizes-extra-small-line-height) rounded",
        className
      )}
    >
      {children}
    </div>
  );
}
